import './bootstrap';
import celebrationPlugin from './plugins/celebration.js';
import undoRedoPlugin from './plugins/undo-redo.js';

// Alpine.js is loaded and started automatically by Livewire 3.
// Do NOT import or start Alpine here — it causes "multiple instances" errors.

// Register Alpine plugins before Livewire starts Alpine
document.addEventListener('alpine:init', () => {
    Alpine.plugin(celebrationPlugin);
    Alpine.plugin(undoRedoPlugin);
});

// Tour panel is registered inline in the Blade layout (after @livewireScripts)
// to ensure Alpine is available. See: resources/views/components/layouts/app.blade.php
